import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import en from 'element-plus/dist/locale/en.mjs'

// ECharts 全局注册
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { BarChart, PieChart, LineChart } from 'echarts/charts';
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
} from 'echarts/components';

// 全局一次性注册所有组件 ✅ 正确
echarts.use([
  CanvasRenderer,
  LineChart,
  BarChart,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
]);

import App from './App.vue'
import router from './router'
import i18n from './i18n'
import './styles/index.scss'

const app = createApp(App)

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 从图标库中获取Loading图标
const { Loading } = ElementPlusIconsVue

// 根据当前语言设置Element Plus的语言
const getElementPlusLocale = () => {
  const currentLang = i18n.global.locale.value
  return currentLang === 'zh-CN' ? zhCn : en
}

app.use(createPinia())
app.use(router)
app.use(i18n)
app.use(ElementPlus, {
  locale: getElementPlusLocale(),
  size: 'default',
  zIndex: 3000,
  loading: {
    spinner: Loading
  }
})

// 挂载到全局
app.config.globalProperties.$echarts = echarts;

// 配置 Vue-ECharts 使用全局 ECharts 实例
import VChart from 'vue-echarts'
// 注册 VChart 为全局组件
app.component('VChart', VChart)

app.mount('#app')

